import { useLocation, useNavigate } from 'react-router-dom';
import useFetch from '../../../../components/useFetch';
import Sidenav from '../../../navbar/Sidenav';
import { AnalyticsIcon, BackIcon, CalendarIcon, ChevronDownIcon, CircleTimeIcon, CreditcardIcon, CreditCardIcon, EmailIcon, ExclamationIcon, FilterIcon, GearIcon, HistoryIcon, HistoryTimeIcon, InfoIcon, LinkIcon, LocationIcon, PlusIcon, TenantIcon, ToggleOffIcon, ToggleOnIcon, TrustIcon, UserIcon, UsersIcon } from '../../../Common/SvgIcons/WorkflowIcons';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import '../../Admin.scss';
import { transform } from 'lodash';
import { useEffect, useState } from 'react';
import { BillingTable } from '../Common/BillingTable';
import { RecentLogs } from '../Common/RecentLogs';
import TenantEditConfig from './TenantEditConfig';
import getDataFromApi from '../../../../components/getDataFromApi';
import TitleHeader from '../../../project/header/TitleHeader';
import PathBreadcrumb from '../../../../components/PathBreadcrumb/PathBreadcrumb';
import { Skeleton } from '@mui/material';


const TenantDetails = () => {

  const [id, setId] = useState('')


  const location = useLocation();
  const role = localStorage.getItem("role");

  const [showEditModal, setShowEditModal] = useState(false);
  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const [editMode, setEditMode] = useState("EXCLUDE_BILLING");
  const [otherPaymentsOpen, setOtherPaymentsOpen] = useState(false);

  const [statusLoading, setStatusLoading] = useState(false);

  const handleActiveTenant = () => {
    if (!id || statusLoading) return;

    setStatusLoading(true);

    getDataFromApi(
      `${window.ENV.API_URL}/forms/admin/update_tenant/${id}`,
      "post",
      { "Tenant Status": "active" }
    )
      .then(() => {
        tenantRefecth(); // soft reload
      })
      .finally(() => {
        setStatusLoading(false);
      });
  };


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tenantIdFromUrl = params.get("tenant_id");

    // Prefer navigation state, then URL (Success/Failed redirect), then localStorage
    if (location.state?.id) {
      setId(location.state.id);
    } else if (tenantIdFromUrl) {
      setId(tenantIdFromUrl);
    } else {
      setId(localStorage.getItem("tenant_id"));
    }
  }, [location.search, location.state?.id])


  const navigate = useNavigate();





  const { data: tenantdata, loading: tenantloading, error: tenantError, refetch: tenantRefecth } = useFetch(id ? `admin/tenant/${id}` : null, "get");
  const { data: usersdata, loading: usersloading, error: usersError, refetch: usersRefecth } = useFetch(id ? `users?page=1&per_page=3&filter=tenant_id=${id},status=active` : null, "get");

  const handleCancelSubscription = async () => {
    const subscriptionId = tenantdata?.subscription_details?.subscription_id;

    if (!subscriptionId) {
      alert("Subscription ID not found");
      return;
    }

    const confirmCancel = window.confirm(
      "Are you sure you want to cancel this subscription?"
    );

    if (!confirmCancel) return;

    const url = `${window["ENV"].API_URL}/admin/subscription/${subscriptionId}`;

    try {
      const response = await getDataFromApi(url, "delete");

      // If request didn't throw error → it was 200
      if (response?.message) {
        // setSuccessMessage(response.message);
      }

      // Refresh tenant details
      tenantRefecth();

    } catch (e) {
      console.error(e);

      if (e.message?.includes("unauthorised")) {
        alert("🚫 You are not authorised to cancel this subscription.");
      } else {
        alert("Failed to cancel subscription.");
      }
    }
  };



  const openEditConfig = () => {
    setEditMode("EXCLUDE_BILLING");
    setShowEditModal(true);
  };

  const openBillingOnly = () => {
    setEditMode("BILLING_ONLY");
    setShowEditModal(true);
  };


  const hasError = !!tenantError;
  const hasData = !!tenantdata;
  const isTenantAdmin = role === 'tenant_admin';
  const isSystemAdmin = role === 'system_admin';
  const isTenantActive = tenantdata?.status === 'active';
  const showQuickActions = isTenantAdmin || isSystemAdmin;


  // console.log('data', location.state?.id, data)

  const resourcesArray = tenantdata?.resources
    ? Object.entries(tenantdata.resources)
    : [];

  const getColor = (percentage) => {
    if (percentage > 85) return "#dc3545"; // red
    if (percentage > 60) return "#ffc107"; // yellow
    return "var(--leading-color)"; // green
  };

  const defaultPaymentMethod =
    tenantdata?.billing_details?.payment_methods?.find(
      (pm) => pm.is_default
    );

  const otherPaymentMethods =
    tenantdata?.billing_details?.payment_methods?.filter(
      (pm) => !pm.is_default
    ) || [];


  const getCardLogo = (brand) => {
    switch (brand?.toLowerCase()) {
      case "visa":
        return "/ico/CardLogos/visa.png";
      case "mastercard":
        return "/ico/CardLogos/mastercard.jpeg";
      case "amex":
      case "american express":
        return "/ico/CardLogos/amex.png";
      case "discover":
        return "/ico/CardLogos/discover.png";
      case "maestro":
        return "/ico/CardLogos/maestro.png";
      case "rupay":
        return "/ico/CardLogos/rupay.png";
      default:
        return "/ico/CardLogos/default-card.svg";
    }
  };


  useEffect(() => {
    if (!tenantloading && tenantdata && !initialLoadDone) {
      setInitialLoadDone(true);
    }
  }, [tenantloading, tenantdata, initialLoadDone]);

  const showInitialSkeleton = (!id || tenantloading) && !initialLoadDone;

  if (showInitialSkeleton) {
    return (
      <>
        <div className={`mainmenu de-width${role === 'system_admin' ? ' pt-3' : ' projects-content'}`}>
          {role === 'system_admin' && (
            <PathBreadcrumb
              onBack={() => navigate('/admin/tenants')}
              items={[
                { label: 'Admin', onClick: () => navigate('/admin') },
                { label: 'Tenants', onClick: () => navigate('/admin/tenants') },
                { label: 'Tenant' },
              ]}
            />
          )}

          <div className={`d-a justify-content-between gap-3${role === 'system_admin' ? ' pt-1' : ' de-header-tag'}`}>
            <div className="d-a gap-3 flex-fill">
              <Skeleton
                variant="rounded"
                width={40}
                height={40}
                className="landing-page-main-icon flex-shrink-0"
              />
              <div className="title-header__copy">
                <Skeleton variant="text" width={220} height={36} />
                <Skeleton variant="text" width={280} height={22} className="mt-1" />
              </div>
            </div>
          </div>

          {role === 'tenant_admin' && (
            <div className="admin-metric-row mt-4 pb-2">
              {[...Array(4)].map((_, idx) => (
                <div
                  key={idx}
                  className="container-card dashboard-cards position-relative overflow-hidden"
                  style={idx === 0 ? { borderLeft: '4px solid var(--leading-color)' } : {}}
                >
                  <Skeleton variant="circular" width={28} height={28} />
                  <Skeleton variant="text" width={70} height={18} />
                  <Skeleton variant="text" width={36} height={22} />
                </div>
              ))}
            </div>
          )}

          <div className="d-flex gap-4 admin-content mt-4">
            <div className="admin-content-card1">
              <section className="container-card d-flex align-items-start justify-content-between">
                <Skeleton variant="circular" width={56} height={56} />
                <div className="flex-fill ms-2">
                  <div className="d-a gap-3 flex-wrap">
                    <Skeleton variant="text" width={180} height={34} />
                    <Skeleton variant="rounded" width={70} height={22} />
                  </div>
                  <div className="d-flex flex-wrap align-items-start align-items-sm-center flex-column flex-sm-row gap-2 mt-1 mb-2">
                    <Skeleton variant="text" width={160} height={20} />
                    <Skeleton variant="text" width={120} height={20} />
                  </div>
                  <Skeleton variant="text" width={140} height={18} />
                </div>
              </section>

              <Skeleton variant="rounded" width="100%" height={56} className="mt-0" />

              {(role === 'system_admin' || role === 'tenant_admin') && (
                <>
                  <Skeleton variant="text" width={110} height={22} className="mt-4 mb-3" />
                  <div className="row g-3">
                    {[...Array(4)].map((_, idx) => (
                      <div key={idx} className="col-12 col-sm-6">
                        <div className="container-card p-3 d-flex align-items-center gap-2">
                          <Skeleton variant="circular" width={36} height={36} />
                          <div className="flex-fill">
                            <Skeleton variant="text" width="55%" height={22} />
                            <Skeleton variant="text" width="75%" height={18} />
                          </div>
                          <Skeleton variant="circular" width={18} height={18} />
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}

              <section className="container-card admin-quota-section mt-4 p-4">
                <div className="d-a gap-2 mb-4">
                  <Skeleton variant="circular" width={22} height={22} />
                  <Skeleton variant="text" width={180} height={24} />
                </div>
                <div className="admin-quota-grid">
                  {[...Array(4)].map((_, idx) => (
                    <div key={idx} className="admin-quota-item">
                      <div className="d-flex justify-content-between mb-1 flex-wrap gap-2 admin-quota-item__header">
                        <Skeleton variant="text" width={140} height={24} />
                        <Skeleton variant="text" width={100} height={24} />
                      </div>
                      <Skeleton variant="rounded" width="100%" height={8} className="admin-quota-item__bar" />
                      <Skeleton variant="text" width={100} height={18} className="mt-2 admin-quota-item__consumed" />
                    </div>
                  ))}
                </div>
              </section>

              <section className="container-card mt-4 p-4">
                <div className="d-a gap-2 mb-3">
                  <Skeleton variant="circular" width={22} height={22} />
                  <Skeleton variant="text" width={140} height={24} />
                </div>
                {[...Array(3)].map((_, idx) => (
                  <Skeleton key={idx} variant="rounded" width="100%" height={44} className="mb-3" />
                ))}
              </section>
            </div>

            <div className="admin-content-card2">
              <section className="container-card">
                <Skeleton variant="text" width={140} height={20} className="mb-3" />
                <Skeleton variant="text" width="70%" height={22} />
                <Skeleton variant="text" width="55%" height={18} className="mb-3" />
                <Skeleton variant="rounded" width="100%" height={72} className="mb-3" />
                <Skeleton variant="rounded" width="100%" height={72} />
              </section>

              <section className="container-card mt-4">
                <Skeleton variant="text" width={120} height={24} className="mb-3" />
                {[...Array(4)].map((_, idx) => (
                  <div key={idx} className="mb-3">
                    <Skeleton variant="rounded" width="100%" height={44} />
                  </div>
                ))}
              </section>
            </div>
          </div>
        </div>

        <div className="mobile-view-bottom"></div>
      </>
    );
  }


  if (!tenantloading && hasError && !initialLoadDone) {
    const status =
      tenantError?.status ||
      tenantError?.response?.status ||
      tenantError?.response?.tenantdata?.status ||
      500;

    return (
      <>
      
        <div className="d-flex flex-column align-items-center justify-content-center h-100">
          <div
            style={{
              backgroundColor: "#fff8d5",
              border: "1px solid #ffe7a3",
              borderRadius: "4px",
              padding: "14px 24px",
              maxWidth: "600px",
              textAlign: "center",
              fontSize: "0.95rem",
              color: "black",
            }}
          >
            {status === 404
              ? "Tenant not found (404)."
              : status === 403
                ? "You don’t have permission to view this tenant."
                : status === 500
                  ? "Server error (500). Please try again."
                  : "Unable to load tenant details right now."}
          </div>

          <Button
            color="primary"
            className="mt-3"
            onClick={() => tenantRefecth()}
          >
            Retry
          </Button>
        </div>
      </>
    );
  }



  if (!tenantloading && !hasData && !initialLoadDone) {
    return (
      <>
      
        <div className="d-flex flex-column align-items-center justify-content-center h-100">
          <div style={{ fontSize: "3rem" }}>🏢</div>
          <h5 className="fw-semibold mt-3">Tenant data unavailable</h5>
          <p className="text-secondary text-center" style={{ maxWidth: "400px" }}>
            This tenant has no associated data yet.
          </p>
        </div>
      </>
    );
  }

  return (
    <>

      <div className={`mainmenu de-width${role === 'system_admin' ? ' pt-3' : ' projects-content'}`}>

        {role === 'system_admin' && (
          <PathBreadcrumb
            onBack={() => navigate('/admin/tenants')}
            items={[
              { label: 'Admin', onClick: () => navigate('/admin') },
              { label: 'Tenants', onClick: () => navigate('/admin/tenants') },
              { label: tenantdata?.name || 'Tenant' },
            ]}
          />
        )}

        <div className={`d-a justify-content-between gap-3${role === 'system_admin' ? ' pt-1' : ' de-header-tag'}`}>
          <TitleHeader Icon={TenantIcon} title1={'Tenant'} title2={' Management'} subtext={role === 'system_admin' ? 'Orchestrate tenant clusters' : 'Manage your organization settings, quotas, and users.'} />
        </div>



        {role === 'tenant_admin' &&
          <div className='admin-metric-row mt-4 pb-2'>

            <div className="container-card dashboard-cards position-relative overflow-hidden" style={{ borderLeft: '4px solid var(--leading-color)' }}>
              <TenantIcon className='wf-icon text-primary border-0' />
              <h6 className='fw-normal mt-3 text-secondary'>Team Users</h6>
              <h5 className='m-0 fw-bold'>{usersdata?.total_count}</h5>
              <div className="decor-circle bg-success"></div>
            </div>

            <div className="container-card dashboard-cards position-relative overflow-hidden">
              <AnalyticsIcon className='wf-icon text-primary border-0' />
              <h6 className='fw-normal mt-3 text-secondary'>Resource Cap</h6>
              <h5 className='m-0 fw-bold'>84%</h5>
              <div className="decor-circle" style={{ background: 'yellow' }}></div>
            </div>

            <div className="container-card dashboard-cards position-relative overflow-hidden">
              <HistoryIcon className='wf-icon text-primary border-0' />
              <h6 className='fw-normal mt-3 text-secondary'>Active Plan</h6>
              <h5 className='m-0 fw-bold'>Pro</h5>
              <div className="decor-circle bg-primary"></div>
            </div>

            <div className="container-card dashboard-cards position-relative overflow-hidden">
              <CreditCardIcon className='wf-icon text-primary border-0' />
              <h6 className='fw-normal mt-3 text-secondary'>Billing Health</h6>
              <h5 className='m-0 fw-bold'>Good</h5>
              <div className="decor-circle bg-success"></div>
            </div>
          </div>}



        <div className='d-flex gap-4 admin-content mt-4'>


          <div className='admin-content-card1'>


            <section className='container-card p-0 overflow-hidden'>
              <div className='d-flex align-items-start align-items-sm-center justify-content-between container-card border-0'>
                <div className='wf-icon-blue d-flex align-items-center justify-content-center fw-bold'>
                  {tenantdata?.name
                    ?.split(" ")
                    .map(word => word[0])
                    .join("")
                    .slice(0, 2)
                    .toUpperCase()}
                </div>

                <div className='flex-fill ms-2'>
                  <div className='d-a gap-2'>
                    <h3 className='fw-bold m-0'>{tenantdata?.name}</h3>
                    <span className={` p-0 px-2 border-0 text-uppercase ${tenantdata?.status === 'active' ? 'wf-icon-green' : 'wf-icon-red'}`} style={{ width: 'fit-content', height: 'fit-content', fontSize: '12px' }}>{tenantdata?.status}</span>
                  </div>
                  <div className='d-flex flex-wrap  align-items-start align-items-sm-center flex-column flex-sm-row gap-2 mt-1'>
                    <span className='text-secondary text-nowrap'><EmailIcon className="wf-icon-small" />{tenantdata?.admin_email}</span>


                    <span className='text-secondary d-flex rounded-img d-none d-sm-flex' style={{ width: '5px', height: '5px', background: 'var(--card-color)' }}></span>


                    <span className=" d-a gap-2 fw-semibold" style={{ fontSize: '11px' }}>
                      <CalendarIcon className="wf-icon-small" style={{ width: '12.5px', height: '12.5px' }} />
                      <e style={{ lineHeight: '10px' }}>DUE {tenantdata?.subscription_details?.next_billing_date
                        ? new Date(tenantdata.subscription_details.next_billing_date).toLocaleDateString()
                        : "-"}</e>
                    </span>

                  </div>
                </div>

                <div className='text-end d-none d-sm-flex flex-column'>
                  <span>{tenantdata?.subscription_details?.plan_type?.toUpperCase()}</span>
                  <h6 className='text-primary m-0 text-nowrap cursor-pointer' onClick={() => navigate("/admin/plan-details", { state: { planId: tenantdata?.subscription_details?.plan_id } })}>
                    {tenantdata?.subscription_details?.plan_name}
                    <BackIcon
                      className='wf-icon text-primary'
                      style={{
                        transform: 'rotate(140deg)',
                        marginTop: '-5px'
                      }}
                    />
                  </h6>
                </div>
              </div>


              <div className='p-2 px-4 d-a justify-content-between flex-wrap' style={{ background: 'var(--card-color)' }}>


                <div className=''>
                  <small className='d-a gap-1'>
                    <InfoIcon className='wf-icon-small' />
                    Next billing date{" "}
                    {tenantdata?.subscription_details?.next_billing_date
                      ? new Date(
                        tenantdata.subscription_details.next_billing_date
                      ).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                      : "-"}
                  </small>
                </div>


                <div className='d-a gap-2'>
                  <Button
                    className='bg-main fw-bold text-white btn-click border-0'
                    onClick={() =>
                      navigate("/admin/plans-billing", {
                        state: {
                          tenantId: tenantdata?.id,
                          planId: tenantdata?.subscription_details?.plan_id,
                          planName: tenantdata?.subscription_details?.plan_name,
                        },
                      })
                    }
                  >
                    Upgrade Subscription
                  </Button>
                  <button
                    className='bg-transparent border-0 wf-icon-red plain-wh'
                    onClick={handleCancelSubscription}
                  >
                    Cancel Subscription
                  </button>

                </div>
              </div>
            </section>




            {showQuickActions &&
              <>

                <h6 className='text-secondary mt-4'>Quick Actions</h6>
                <div className="row g-3">
                  <div className="col-12 col-sm-6 cursor-pointer" onClick={openEditConfig}>
                    <div className="container-card quick-action-cards d-flex align-items-center justify-content-between gap-2 p-3 h-100">
                      <GearIcon className="wf-icon-blue border-0" />
                      <div className="flex-grow-1">
                        <h6 className="m-0">Edit Config</h6>
                        <span>Update tenant configuration</span>
                      </div>
                      <LinkIcon className="wf-icon-small text-secondary" />
                    </div>
                  </div>

                  {isSystemAdmin && tenantdata?.status !== 'suspended' &&
                    <div
                      className="col-12 col-sm-6 cursor-pointer"
                      onClick={() => {
                        setEditMode("SUSPEND_ONLY");
                        setShowEditModal(true);
                      }}
                    >
                      <div className="container-card quick-action-cards d-flex align-items-center justify-content-between gap-2 p-3 h-100">
                        <ExclamationIcon className="wf-icon-yellow border-0" />
                        <div className="flex-grow-1">
                          <h6 className="m-0">Suspend Org</h6>
                          <span>Suspend organization access</span>
                        </div>
                        <LinkIcon className="wf-icon-small text-secondary" />
                      </div>
                    </div>}

                  {isSystemAdmin && (
                    <div
                      className={`col-12 col-sm-6 cursor-pointer ${statusLoading ? 'opacity-50' : ''}`}
                      onClick={() => {
                        if (statusLoading) return;

                        if (isTenantActive) {
                          setEditMode("DELETE_ONLY");
                          setShowEditModal(true);
                        } else {
                          handleActiveTenant();
                        }
                      }}
                    >
                      <div className="container-card quick-action-cards d-flex align-items-center justify-content-between gap-2 p-3 h-100">
                        {isTenantActive ?
                          <ToggleOffIcon className="wf-icon-red border-0" /> :
                          <ToggleOnIcon className="wf-icon-green border-0" />}
                        <div className="flex-grow-1">
                          <h6 className="m-0">{isTenantActive ? 'Inactive Tenant' : 'Active Tenant'}</h6>
                          <span>{isTenantActive ? 'Mark tenant as inactive' : 'Restore tenant access'}</span>
                        </div>
                        <LinkIcon className="wf-icon-small text-secondary" />
                      </div>
                    </div>
                  )}

                  {isTenantAdmin && <div className="col-12 col-sm-6 cursor-pointer" onClick={() => { navigate('/admin/users') }}>
                    <div className="container-card quick-action-cards d-flex align-items-center justify-content-between gap-2 p-3 h-100">
                      <UsersIcon className="wf-icon-blue border-0" />
                      <div className="flex-grow-1">
                        <h6 className="m-0">Users & Roles</h6>
                        <span>Manage your team members</span>
                      </div>
                      <LinkIcon className="wf-icon-small text-secondary" />
                    </div>
                  </div>}


                  {/* {isTenantAdmin && <div className="col-12 col-sm-6 cursor-pointer">
                    <div className="container-card quick-action-cards d-flex align-items-center justify-content-between gap-2 p-3 h-100">
                      <HistoryTimeIcon className="wf-icon-purple" />
                      <div className="flex-grow-1">
                        <h6 className="m-0">Resource Monitoring</h6>
                        <span>Compute and storage quotas</span>
                      </div>
                      <LinkIcon className="wf-icon-small text-secondary" />
                    </div>
                  </div>} */}
                </div>  </>}



            <section className='container-card admin-quota-section mt-4'>
              <div className='d-a gap-2 mb-3'>
                <AnalyticsIcon className='wf-icon' />
                <h6 className='m-0'>Quota & Resource Usage</h6>
              </div>

              <div className='admin-quota-grid mt-4'>
                {resourcesArray.map(([key, resource]) => {
                  const percentage =
                    resource.limit > 0
                      ? Math.min((resource.usage / resource.limit) * 100, 100)
                      : 0;

                  return (
                    <div key={resource.id} className="admin-quota-item">
                      <div className='d-flex justify-content-between mb-1 flex-wrap gap-2 admin-quota-item__header'>
                        <h6 className='fw-semibold'>{key}</h6>
                        <span>
                          {resource.usage} / {resource.limit}{" "}
                          {resource.unit !== "count" ? resource.unit : ""}
                        </span>
                      </div>

                      <div
                        className="admin-quota-item__bar"
                        style={{
                          height: "8px",
                          background: "var(--card-color)",
                          borderRadius: "6px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            width: `${percentage}%`,
                            height: "100%",
                            background: getColor(percentage),
                            transition: "width 0.3s ease",
                          }}
                        />
                      </div>

                      <div className='text-secondary mt-2 small-font admin-quota-item__consumed'>
                        CONSUMED: {percentage.toFixed(0)}%
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>


            <div className='container-card mt-4'>
              <div className='d-a justify-content-between'>
                <div className='d-a gap-2'>
                  <CreditcardIcon className='wf-icon' />
                  <h6 className='m-0'>Billing Activity</h6>
                </div>
                {/* <button className='plain-button fw-bold'
                  onClick={() => navigate('/admin/billing-activity', { state: { url: 'admin/billings?page=1&per_page=50', tenantname: true } })}>View All Invoices</button> */}              </div>

              <BillingTable billingUrl={id ? `admin/billings?page=1&per_page=5&filter=tenant_id=${id}` : undefined} />
            </div>
          </div>

          <div className='admin-content-card2'>


            <section className="container-card bg-main-container">
              <div className="d-a justify-content-between">
                <span className="text-secondary fw-bold small-font">
                  FINANCIAL PROFILE
                </span>
                <TrustIcon className="wf-icon text-primary" />
              </div>

              {tenantdata?.billing_details ? (
                <div className="mt-4">

                  {/* Billing Entity */}
                  <span className="text-secondary small-font text-secondary">BILLING ENTITY</span>
                  <br />
                  <span className="mt-1 mb-0" style={{ color: '#c8d9e7' }}>{tenantdata.billing_details.name}</span>
                  <br />
                  <span className="small-font m-0" style={{ color: '#c8d9e7' }}><EmailIcon className='wf-icon-small' /> {tenantdata.billing_details.email}</span>

                  <div className="small-font" style={{ color: '#c8d9e7' }}>
                    {tenantdata?.billing_details?.Address ? (
                      <><LocationIcon className='wf-icon-small me-1' />
                        {tenantdata.billing_details.Address.line1},{" "}
                        {tenantdata.billing_details.Address.city},{" "}
                        {tenantdata.billing_details.Address.state},{" "}
                        {tenantdata.billing_details.Address.country} -{" "}
                        {tenantdata.billing_details.Address.postal_code}
                      </>
                    ) : (
                      "Not Provided"
                    )}
                  </div>


                  {/* Primary Payment Method */}
                  {defaultPaymentMethod && (
                    <div className="mt-4">
                      <span className="text-secondary small-font">
                        PRIMARY PAYMENT METHOD
                      </span>

                      <div
                        className="mt-2 p-3 rounded d-flex align-items-center justify-content-between mx-4"
                        style={{
                          background: "rgb(225 225 225 / 6%)",
                        }}
                      >
                        <div className='d-a gap-2'>
                          {/* <span className='bg-primary rounded p-2 fw-bold text-white'>{defaultPaymentMethod.brand?.toUpperCase()}</span> */}

                          <img
                            src={getCardLogo(defaultPaymentMethod?.brand)}
                            alt={defaultPaymentMethod?.brand}
                            style={{
                              height: "28px",
                              objectFit: "contain"
                            }}
                          />

                          <div>
                            <div className="fw-semibold" style={{ color: '#a3d1f1c2' }}>
                              •••• •••• •••• {defaultPaymentMethod.last4}
                            </div>

                            <div className="small-font" style={{ color: 'rgb(189 189 189 / 76%)' }}>
                              Expires {defaultPaymentMethod.exp_month}/
                              {defaultPaymentMethod.exp_year}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}



                  {otherPaymentMethods.length > 0 && (
                    <div className="mt-4">
                      <button
                        type="button"
                        className="tenant-other-payments__toggle w-100 d-a justify-content-between gap-2 border-0 bg-transparent p-0 text-start"
                        onClick={() => setOtherPaymentsOpen((open) => !open)}
                        aria-expanded={otherPaymentsOpen}
                      >
                        <span className="text-secondary small-font">
                          OTHER PAYMENT METHODS
                          <span className="ms-2" style={{ color: '#a3d1f1c2' }}>
                            ({otherPaymentMethods.length})
                          </span>
                        </span>
                        <ChevronDownIcon
                          className={`wf-icon-small tenant-other-payments__chevron${otherPaymentsOpen ? ' is-open' : ''}`}
                        />
                      </button>

                      {otherPaymentsOpen && (
                        <div className="tenant-other-payments__list mt-2">
                          {otherPaymentMethods.map((pm) => (
                            <div
                              key={pm.id}
                              className="mt-2 p-3 rounded d-flex align-items-center justify-content-between mx-4"
                              style={{
                                background: "rgb(225 225 225 / 6%)",
                              }}
                            >
                              <div className='d-a gap-2'>
                                <img
                                  src={getCardLogo(pm.brand)}
                                  alt={pm.brand}
                                  style={{
                                    height: "28px",
                                    objectFit: "contain"
                                  }}
                                />

                                <div>
                                  <div className="fw-semibold" style={{ color: '#a3d1f1c2' }}>
                                    •••• •••• •••• {pm.last4}
                                  </div>

                                  <div className="small-font" style={{ color: 'rgb(189 189 189 / 76%)' }}>
                                    Expires {pm.exp_month}/{pm.exp_year}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}



                  {/* </div> */}

                  <button className="w-100 border-0 shadow rounded py-3 text-white fw-bold mt-4" style={{ background: '#d9d9d940' }} onClick={openBillingOnly}
                  >
                    <FilterIcon className="wf-icon text-white me-2" />
                    Update Billing Info
                  </button>
                </div>
              ) : (
                <>
                  <div className="my-4 d-j-a flex-column">
                    <CreditCardIcon
                      className="wf-icon-yellow rounded-img bg-transparent"
                      style={{ width: "60px", height: "60px" }}
                    />
                    <h6 className="text-white mt-4">Missing Billing Data</h6>
                    <span className="small-font text-secondary w-75 text-center">
                      Add billing details to avoid service interruption.
                    </span>
                  </div>

                  <button className="w-100 border-0 shadow rounded py-3 text-white fw-bold" style={{ background: '#d9d9d940' }} onClick={openBillingOnly}
                  >
                    <PlusIcon className="wf-icon text-white me-2" />
                    Add Billing Details
                  </button>
                </>
              )}
            </section>




            <section className="container-card my-4 position-relative">
              <div className='d-a justify-content-between'>
                <div className='d-a gap-2'>
                  <UsersIcon className='wf-icon-small' />
                  <span className=' text-secondary fw-bold'>Workspace Users</span>
                </div>
                <h3 className=' fw-bold text-primary'>{usersdata?.total_count}</h3>
              </div>


              <TenantIcon className='text-primary' style={{ position: 'absolute', opacity: '0.08', width: '60px', height: '60px', right: 5, }} />

              {usersdata?.total_count > 0 ?
                <>
                  {usersdata?.results?.map((u) => (
                    <div className='d-a gap-2 mt-4 cursor-pointer' onClick={() =>
                      navigate("/admin/user-details", {
                        state: { id: u.id, viewFrom: "user_details" }
                      })
                    }>
                      <span className='wf-icon-blue rounded-img  fw-bold border-0'>AT</span>
                      <div className='d-flex flex-column'>
                        <span className='fw-bold '>{u?.name}</span>
                        <span className='text-secondary'>{u?.roles}</span>
                      </div>
                    </div>))}
                </>
                :
                <div className='d-j-a text-secondary mt-4'>No users are created in this tenant yet</div>}


              <Button className=' text-white bg-main mt-5 py-3   border-0 fw-bold w-100'
                onClick={() =>
                  navigate("/admin/users", {
                    state: {
                      id: tenantdata?.id,
                      tenantName: tenantdata?.name,
                      openCreate: !(usersdata?.total_count > 0),
                    }
                  })}>
                {usersdata?.total_count > 0 ? 'View all users' : 'Add User'}
              </Button>
            </section>


            <RecentLogs viewFrom={'Tenant'} tenantId={id} />
          </div>


        </div>

      </div>


      <TenantEditConfig
        showModal={showEditModal}
        onClose={() => setShowEditModal(false)}
        onSubmit={() => {
          tenantRefecth(); // refresh tenant details after update
          setShowEditModal(false);
        }}
        tenantId={id}
        mode={editMode}
        prefill={tenantdata}
      />


      <div className="mobile-view-bottom"></div>

    </>
  )
}

export default TenantDetails
